import { type GetArchivedSubmissionsParams } from '@framework/api-client';
import { yup } from '@framework/validation';

export const ArchivedSubmissionsQuerySchema =
  yup.object<GetArchivedSubmissionsParams>({
    oggetto: yup
      .string()
      .trim()
      .allowNullable({ alwaysUndefined: true })
      .min(3)
      .notRequired()
      .label('Oggetto'),
    codice: yup
      .string()
      .trim()
      .allowNullable({ alwaysUndefined: true })
      .min(3)
      .notRequired()
      .label('Codice'),
    protocollo: yup
      .string()
      .trim()
      .allowNullable({ alwaysUndefined: true })
      .min(3)
      .notRequired()
      .label('Numero Protocollo'),
    dataInvioDal: yup
      .string()
      .stringDate()
      .allowNullable({ alwaysUndefined: true })
      .notRequired()
      .label('Data Invio Dal'),
    dataInvioAl: yup
      .string()
      .stringDate()
      .allowNullable({ alwaysUndefined: true })
      .notRequired()
      .label('Data Invio Al'),
  });
